import { Card, Table } from "react-bootstrap";
import { Fragment, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { searchCommands, deleteCommand, getMyCommands } from "../store/api/CommandsAPI";
import TableRow from "../Components/Tasks/TableRow";
import { setDialog } from "../store/api/GetAllProduct";
import { CaretLeftFill, CaretRightFill } from "react-bootstrap-icons";
import { downloadFile } from "../../store/api/CommonFunctions";
import { useState } from "react";
import ModalCommands from "../../Components/Modals/ModalCommands";
let totalPage = 0;
const MyCommands = () => {
    const commandList = useSelector(state => state.CommandsReducer.myCommands);
    const currPage = useRef(1);
    const searchData = useRef({});
    const [popCommand, setPopCommand] = useState({ show: false });
    const totalCount = commandList && commandList.TotalCount ? Number(commandList.TotalCount) : 0;
    if (totalPage < 1) {
        totalPage = Math.floor(totalCount / 10) + ((totalCount % 10) > 0 ? 1 : 0);
    }
    const dispatch = useDispatch();
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        async function getData() { dispatch(getMyCommands({})); }
        getData();
    }, []);
    const search = () => {
        searchData.current.Skip = currPage.current - 1;
        searchData.current.Take = 10;
        dispatch(getMyCommands(searchData.current));
    }
    const history = useHistory();
    function showCommand(cmd) {
        setPopCommand({
            show: true,
            attachmentType: cmd.AttachmentType,
            attachmentID: cmd.AttachmentID,
            id: cmd.ID,
            onAddEdit: () => dispatch(getMyCommands(searchData.current))
        })
    }
    const showRelated = (cmd) => {
        if (!cmd.AttachmentID || cmd.AttachmentID === '') {
            return;
        }
        if (cmd.AttachmentType === "repair" || cmd.AttachmentType === "install") {
            history.push(`/Services/Service/${cmd.AttachmentID}/${cmd.AttachmentType}`, null);
        }
    }
    const changePage = (inc) => {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        search();
    }
    const tableColes = [
        { colTitle: "موضوع", colName: "Subject", showInMobile: true },
        { colTitle: "متن پیام", colName: "FirstMessage", showInMobile: true, maxTextLength: 150, colType: "string" },
        { colTitle: "اولویت", colName: "PriorityName", showInMobile: true },
        { colTitle: "تاریخ ایجاد", colName: "pCreationDate", showInMobile: false },
        { colTitle: "تاریخ یادآوری", colName: "pAlarmDate", showInMobile: false },
        { colTitle: "ایجاد کننده", colName: "CreateByName", showInMobile: false },
        { colTitle: "تعداد پاسخ ها", colName: "MessageCounts", showInMobile: false, colType: "number" }
    ]
    const tableRowButtons = [
        {
            title: "حذف دستور", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف دستور کار',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteCommand(item.ID, () => dispatch(getMyCommands(searchData.current)))
                }))
            }
        },
        {
            title: "نمایش دستور", type: "show", className: "group-Btn-smalll btn-success", onclick: showCommand
        },
        {
            title: "پیوست", type: "attach", className: "group-Btn-smalll btn-primary", showCondition: (item) => item.FirstMessageHasAttach,
            onclick: (item) => { downloadFile(item.FirstMessageID, "command") }
        },
        {
            title: "فرم مرتبط", type: "related", className: "group-Btn-smalll btn-secondary", showCondition: (item) => item.AttachmentType !== null && item.AttachmentID !== -1,
            onclick: (item) => { showRelated(item) }
        }

    ]
    function handleIsDoneChange(e) {
        const isDone = e.target.checked ? false : null;
        searchData.current.IsDone = isDone;
        dispatch(getMyCommands({Take: 10, IsDone: isDone}));
    }
    return (<div className="container-fluid mt-1" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <ModalCommands popData={popCommand} setPopData={setPopCommand} />
            <Card.Header className="headerStyle">دستور کارهای من</Card.Header>
            <Card.Body className="bodyStyle">
                <div className="text-end">
                    <input id="chkIsDone" className="form-check-input" type="checkbox" onChange={handleIsDoneChange} />&nbsp;
                    <label htmlFor="chkIsDone">تنها موارد انجام نشده را نشان بده</label>
                </div>
                {commandList && commandList !== '' &&
                    <Fragment>
                        <Table responsive={true} className="mt-3">
                            <thead>
                                <tr>
                                    <th style={{ display: "none" }}></th>
                                    <th>موضوع</th>
                                    <th>متن پیام</th>
                                    <th>اولویت</th>
                                    {window.innerWidth > 414 &&
                                        <Fragment>
                                            <th>تاریخ ایجاد</th>
                                            <th>تاریخ یادآوری</th>
                                            <th>ایجاد کننده</th>
                                            <th>تعداد پاسخ ها</th>
                                            <th></th>
                                        </Fragment>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {commandList === "PENDING" &&
                                    <tr>
                                        <td colSpan={8} style={{ textAlign: "center" }}>
                                            <Loader type="BallTriangle" color="#bb1370" height={30} />
                                        </td>
                                    </tr>}
                                {commandList?.List && Array.isArray(commandList.List) &&
                                    commandList.List.map((item, i) =>
                                        <TableRow key={i} row={item} buttons={tableRowButtons} indx={i} cols={tableColes} />)
                                }
                            </tbody>

                        </Table>
                        <div>
                            <button className="btn btn-block" style={{ padding: "2px", marginLeft: "3px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                            <span>{currPage.current + " از " + totalPage} {totalCount && totalCount > 0 && <span style={{ color: "gray" }}>({totalCount})</span>}</span>
                            <button className="btn btn-block" style={{ padding: "2px", marginRight: "3px" }} title='صفحه بعد' disabled={currPage.current === totalPage} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                        </div>
                    </Fragment>
                }
            </Card.Body>

        </Card>
    </div>
    );
}
export default MyCommands;